"use client";
import { CardSlider } from "@/components/card_slider/card_slider";
import { FundCard } from "@/components/fund_card/fund_card";
import { type FundData } from "@/model/db";
import { ReactElement, useState } from "react";

interface Props {
  noActive?: boolean;
  funds: FundData[];
}

export function FundsSlider({ noActive, funds }: Props): ReactElement {
  const [current, setCurrent] = useState(0);

  return (
    <CardSlider noActive={noActive} value={current} onChange={setCurrent}>
      {funds?.map((fund, index) => {
        const active = current === index;
        const Wrapper = active ? "a" : "div";
        const path = fund.assetClass === "etf" ? "etfs" : "funds";

        return (
          <Wrapper
            key={fund.id}
            href={active ? `/solutions/${path}/${fund.id}` : undefined}
          >
            <FundCard {...fund} active={!noActive && current === index} />
          </Wrapper>
        );
      })}
    </CardSlider>
  );
}
